export default {
	page_title: 'Schedule',
	day: 'Day {number}',
	'table.activity': 'Activity',
	'table.period': 'Period',
	'table.description': 'Prizes and information',
};
